<div>
  <ng-container *ngIf="isSearchMenuVisible">
    <div
      *ngIf="true || !showNoResultsFound"
      class="comparative-search-menu-container"
    >
      <ul class="comparative-menu-list">
        <li
          *ngFor="let item of menuList"
          (click)="handleMenuItemClick(item, $event)"
          (mouseenter)="handleMenuItemMouseEnter(item, $event)"
          (mouseleave)="handleMenuItemMouseLeave(item, $event)"
          class="comparative-menu-list-item"
          [ngClass]="{
            selected: activatedOptions === item.id,
            disabled:
              (!item.isLeaf && !menuSearchCount[item.id]) || item.disabled
          }"
        >
          <span>{{ item.label }}</span>
          <div class="display-flex flex-align-center" *ngIf="!item.isLeaf">
            <!-- <span *ngIf="searchedTerm"> {{ menuSearchCount[item.id] }}</span> -->
            <div class="arrow-icon">
              <va-icon size="small" name="chevron-right"></va-icon>
            </div>
          </div>
        </li>
      </ul>

      <div class="comparative-menu-right-section" [ngSwitch]="activatedOptions">
        <div *ngSwitchCase="'industry'">
          <app-industry-menu
            [data]="industryMenuData"
            [searchedValue]="searchedTerm"
            [isLoading]="isIndustryMenuApiInProgress"
            [isMcapGeoDataLoading]="isMarketGeoApiInProgress"
            [marketCapData]="marketCapData"
            [geographyData]="geographyData"
            [shouldEmitTickerList]="true"
            [isCreateNewModalIndustryMenu]="isCreateNewModalIndustryMenu"
            (onCancelButtonClick)="handleMenuCancelButtonClick()"
            (onApplyButtonClick)="handleMenuApplyButtonClick($event)"
          ></app-industry-menu>
        </div>
        <div *ngSwitchCase="'watchlist'">
          <app-watchlist-search-menu
            [data]="watchlistMenuData"
            [isLoading]="isWatchlistMenuApiInProgress"
            [isMcapGeoDataLoading]="isMarketGeoApiInProgress"
            [marketCapData]="marketCapData"
            [geographyData]="geographyData"
            [isCreateNewModalIndustryMenu]="isCreateNewModalIndustryMenu"
            (onCancelButtonClick)="handleMenuCancelButtonClick()"
            (onApplyButtonClick)="handleMenuApplyButtonClick($event)"
          ></app-watchlist-search-menu>
        </div>
      </div>
    </div>

    <div *ngIf="showNoResultsFound" class="no-results">
      No results for "{{ searchedTerm }}"
    </div>
  </ng-container>
</div>
